export class HtmlAttribute {
  public static DATA_CKE_TOOLTIP_TEXT = 'data-cke-tooltip-text';
  public static DATA_USERTOOLTIP = 'data-usertooltip';
  public static SUBTEMPLATE_NAME = 'data-subtemplate-name';
  public static NO_ONE = 'data-noone';
  public static SUBTEMPLATES_ALLOW = 'data-subtemplates-allow';
  public static SUBTEMPLATES_RULES = 'data-subtemplates-rules';
  public static CONTENTEDITABLE = 'contenteditable';
  public static DATA_TEMPLATE = 'data-template';
  public static DATA_COMMENT_ID = 'data-comment-id';
  public static CITATION_COUNT = 'data-citationcount';
  public static PARENT_CITATION = 'data-parentcitation';
  public static NUMBERED_CITATION = 'numberedcitation';
  public static RESOURCE = 'resource';
  public static TYPE_OF = 'typeof';
  public static DATA_IGNORE = 'data-ignore';
  public static DATA_UNLOCK = 'data-unlock';
  public static DATA_HIDEROWS = 'data-hiderows';
  public static DATA_SHOWROWS = 'data-showrows';
  public static TRACK_CHANGES_EDITING = 'TrackChangesEditing';
  public static LINK_HREF = 'linkHref';
  public static DATA_COMMENT = 'data-comment';
  public static RENUMBER_CITATIONS = 'renumbercitations';
  public static REMOVE_INSERTEDCITATION_DISCARD =
    'removeInsertedCitationsOnDiscard';
  public static DATA_THREAD_ID = 'data-thread-id';
  public static DATA_COMMENT_THREAD_ID = 'data-comment-thread-id';
  public static ID = 'id';
  public static CLASS = 'class';
  public static HTML_ATTRIBUTES = 'htmlAttributes';
  public static NUMBERED_CITATION_CLASS = 'numbered-citation';
  public static REL = 'rel';
}
